import React, { createContext, ReactNode, useContext, useState } from 'react';

interface SearchBarProps {
  value: string;
  active: boolean;
  setValue: (newValue: string) => void;
  setActive: (activeValue: boolean) => void;
}

const SearchBarContext = createContext<SearchBarProps>({
  value: '',
  active: false,
  setValue: () => {},
  setActive: () => {},
});

export const useSearchBarContext = () => useContext(SearchBarContext);

type SearchBarProviderType = {
  children: ReactNode;
};

export const SearchBarProvider = ({ children }: SearchBarProviderType) => {
  const [value, updateValue] = useState<string>('');
  const [active, updateActive] = useState<boolean>(false);

  const setValue = (newValue: string) => {
    updateValue(newValue);
  };

  const setActive = (activeValue: boolean) => {
    updateActive(activeValue);
  };

  return (
    <SearchBarContext.Provider value={{ value, setValue, active, setActive }}>
      {children}
    </SearchBarContext.Provider>
  );
};
